<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  getList,
  getDetails,
  update,
  del,
  getOutInList,
  outInSubmit,
  setTime,
} from "@/api/tracker/airPacking";
import { updateOrderInfo, getDownPort } from "@/api/packing/packing";
import {
  getCustomer,
  addZhongGang,
  getTransportAgent,
} from "@/api/tracker/air";
import { getWarehouse } from "@/api/storage/warehouse";
import { getUser } from "@/api/user/internal";
import { getSelectType, getKeysType } from "@/api/public";
import { getAllClient } from "@/api/user/client";
import numFun from "@/utils/numFun";
import cTable from "@/base/common/index";
export default {
  name: "airPackingList",
  components: {
    cTable,
  },
  async mounted() {
    let hkAgentList = (await getTransportAgent({ type: 4 })).data.payload;
    let warehouse = (await getWarehouse({ is_oversea: "NO", status: "ENABLE" }))
      .data.payload.rows;
    let userList = (await getUser()).data.payload.rows;
    let downPortList = (await getDownPort()).data.payload;
    this.header.searchs.forEach((item) => {
      if (item.key === "warehouseId") item.options = warehouse;
      if (item.key === "operator") item.options = userList;
    });
    this.modals.update.fields.forEach((item) => {
      if (item.key === "hk_agent") item.options = hkAgentList;
      if (item.key === "lower_port") item.options = downPortList;
    });
  },
  data() {
    let trackList = {
        90: { label: "CustomsReleased", value: 90 },
        91: { label: "CustomsInspection", value: 91 },
        92: { label: "FormalClearance", value: 92 },
        93: { label: "CustomsHold", value: 93 },
      },
      typeList = {
        in: { label: "MoveIn", value: "in" },
        out: { label: "MoveOut", value: "out" },
      },
      globalUrl = this.$globalUrl;
    return {
      methods: {
        list: getList,
        getDetails,
        // showDblpacking: getDetails,
        // addDblpackingTrace,
        update,
        setTime,
        // exportOutboundData,
        del,
        getOutInList,
        outInSubmit,
        getCustomer,
        updateOrderInfo,
        // boundTime,
        // addTrace,
        // handlePacking,
        // exportPacking,
        // exportPackingZip,
        // exportCustomsData
        // confirmError
      },
      modals: {
        update: {
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data["type"] = 3;
              this.$page
                .handleRequestMethods("updateOrderInfo", data, true)
                .then((e) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 20,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {},
          },
          grid: [
						{
						  client_id: 24,
						},
            {
              weight: 24,
            },
            {
              quantity: 24,
            },
            {
              volume: 24,
            },
            {
              liquid_num: 24,
            },
            {
              charged_num: 24,
            },
            {
              charging_weight: 24,
            },
            { hk_agent: 24 },
            { lower_port: 24 },
          ],
          fields: [
						{
							name: () => this.$t("clientName"),
						  key: "client_id",
						  component: "Select",
						  placeholder() {
						    return this.$t("select") + this.$t("clientName");
						  },
						  clearable: true,
						  options: [],
						  config: { label: "account", value: "id" },
						  methods: {
						    async list({ field, row }) {
						      let res = (await getAllClient()).data.payload.rows;
						      field.options = res;
						      this.$forceUpdate();
						    },
						  },
						},
            {
              name: () => this.$t("invoiceWeight"),
              key: "weight",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              },
              default: 0,
            },
            {
              name: () => this.$t("invoicePCS"),
              key: "quantity",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              },
              default: 0,
            },
            {
              name: () => this.$t("skuVolume"),
              key: "volume",
              component: "Input",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return this.$t("enter") + this.$t("skuVolume");
              },
              default: 0,
            },
            {
              name: () => this.$t("liquidPCS"),
              key: "liquid_num",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return this.$t("enter") + this.$t("liquidPCS");
              },
              default: 0,
            },
            {
              name: () => this.$t("ElectricityPCS"),
              key: "charged_num",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return this.$t("enter") + this.$t("ElectricityPCS");
              },
              default: 0,
            },
            {
              name: () => this.$t("Billing") + this.$t("invoiceWeight"),
              key: "charging_weight",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("Billing") +
                  this.$t("invoiceWeight")
                );
              },
              default: 0,
            },
            {
              key: "hk_agent",
              name: () => this.$t("HKagency"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("HKagency");
              },
              options: [],
            },
            {
              key: "lower_port",
              name: () => this.$t("delivery_method"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("delivery_method");
              },
              options: [],
            },
          ],
        },
        settime: {
          type: "add",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("setTime", row, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 400,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date",
                },
              ],
            },
          },
          grid: [{ time: 24 }],
          fields: [
            {
              key: "time",
              name: () => this.$t("select") + this.$t("time"),
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("start") + this.$t("time");
              },
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  },
                },
                clearable: false,
              },
            },
          ],
        },
        track: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addDblpackingTrace", row, true)
                .then((e) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date",
                },
              ],
              status_code: [
                {
                  required: true,
                  message: "Please select the track",
                  trigger: "change",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ time: 24 }, { status_code: 24 }],
          fields: [
            {
              key: "time",
              name: () => this.$t("select") + this.$t("time"),
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("start") + this.$t("time");
              },
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  },
                },
                clearable: false,
              },
            },
            {
              key: "status_code",
              name: () => this.$t("tracker_description"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("tracker_description");
              },
              options: trackList,
              config: {
                label({ row, field }) {
                  return this.$t(row.label);
                },
              },
            },
          ],
        },
        operate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("handlePacking", row, true)
                .then((e) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 20,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              package: [
                {
                  required: true,
                  message: "Please enter the package",
                  trigger: "blur",
                },
              ],
              type: [
                {
                  required: true,
                  message: "Please select the Type",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            {
              package: 24,
            },
            {
              type: 24,
            },
          ],
          fields: [
            {
              name: () => this.$t("enter") + this.$t("bagCode"),
              key: "package",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bagCode");
              },
            },
            {
              name: () => this.$t("type"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("type");
              },
              key: "type",
              options: typeList,
              config: {
                label({ row, field }) {
                  return this.$t(row.label);
                },
              },
            },
          ],
        },
        show: {
          config: {
            listFn: "list",
            modalBind: {
              width: 800,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("packingNum"),
                key: "case_number",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("length"),
                key: "length",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("width"),
                key: "width",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("height"),
                key: "height",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("createTime"),
                key: "create_time",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        inbound: {
          methods: {},
          config: {
            modalBind: {
              width: 1200,
              draggable: true,
            },
            // title: this.$t("inbound")
          },
          footer: {
            show: false,
          },
          table: {
            config: {
              height: 500,
              // showFooter: true,
              // footerCellClassName: "col-red",
              // footerMethod: ({ columns, data }) => {
              //   console.log(columns, data);
              //   const sums = [];
              //   columns.forEach(column => {
              //     let sumCell = null;
              //     switch (column.property) {
              //       case "total":
              //         sumCell = this.$t("total");
              //         break;
              //       case "quantity":
              //         sumCell = sumCell = numFun.sumNumFun(
              //           data,
              //           column.property,
              //           2
              //         );
              //         break;
              //       case "volume":
              //         sumCell = sumCell = numFun.sumNumFun(
              //           data,
              //           column.property,
              //           2
              //         );
              //         break;
              //       case "weight":
              //         sumCell = sumCell = numFun.sumNumFun(
              //           data,
              //           column.property,
              //           2
              //         );
              //         break;
              //       default:
              //         sumCell = "-";
              //         break;
              //     }
              //     sums.push(sumCell);
              //   });
              //   // 返回一个二维数组的表尾合计
              //   return [sums];
              // }
            },
            fields: [
              {
                name: this.$t("gather") + this.$t("invoicePCS"),
                key: "total",
                width: 100,
              },
              {
                name: this.$t("inbound") + this.$t("invoicePCS"),
                key: "quantity",
                component: "Input",
                width: 100,
                placeholder() {
                  return (
                    this.$t("enter") +
                    this.$t("inbound") +
                    this.$t("invoicePCS")
                  );
                },
              },
              {
                name: this.$t("length"),
                key: "length",
                component: "Input",
                placeholder() {
                  return this.$t("enter") + this.$t("length");
                },
              },
              {
                name: this.$t("width"),
                key: "width",
                component: "Input",
                placeholder() {
                  return this.$t("enter") + this.$t("width");
                },
              },
              {
                name: this.$t("height"),
                key: "height",
                component: "Input",
                placeholder() {
                  return this.$t("enter") + this.$t("height");
                },
              },
              {
                name: this.$t("skuVolume"),
                key: "volume",
                component: "Input",
                placeholder() {
                  return this.$t("enter") + this.$t("skuVolume");
                },
              },
              {
                name: this.$t("actual_weight"),
                key: "weight",
                component: "Input",
                placeholder() {
                  return this.$t("enter") + this.$t("actual_weight");
                },
              },
              {
                name: this.$t("Remarks"),
                key: "remarks",
                component: "Input",
                placeholder() {
                  return this.$t("enter") + this.$t("Remarks");
                },
              },
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                // width({ field }) {
                //   return field.list.length * 40 + 40;
                // },
                list: [
                  {
                    name: () => this.$t("order_submit"),
                    type: "submit",
                    fnName: "submitFun",
                    bind: {
                      type: "warning",
                    },
                    show({ row }) {
                      return !row.id;
                    },
                    id: 850,
                  },
                  {
                    name: () => this.$t("update"),
                    type: "update",
                    fnName: "submitFun",
                    bind: {
                      type: "success",
                    },
                    show({ row }) {
                      return "id" in row;
                    },
                    id: 850,
                  },
                ],
                methods: {
                  submitFun({ row, rowIndex, field }) {
                    row["type"] = "in";
                    this.handleRequestMethods("outInSubmit", row, true).then(
                      (e) => {
                        this.handleRequestMethods("getOutInList", {
                          type: "in",
                          id: row.packing_id,
                        }).then((res) => {
                          this.getModal("inbound").list = res.payload.list;
                          if (res.payload.insert) {
                            this.getModal("inbound").list.unshift(
                              res.payload.insert
                            );
                          }
                        });
                        // close();
                      }
                    );
                  },
                },
              },
            ],
          },
        },
        out: {
          methods: {},
          config: {
            modalBind: {
              width: 800,
              draggable: true,
            },
            // title: this.$t("inbound")
          },
          footer: {
            show: false,
          },
          table: {
            config: {
              height: 500,
              // showFooter: true,
              // footerCellClassName: "col-red",
              // footerMethod: ({ columns, data }) => {
              //   console.log(columns, data);
              //   const sums = [];
              //   columns.forEach(column => {
              //     let sumCell = null;
              //     switch (column.property) {
              //       case "total":
              //         sumCell = this.$t("total");
              //         break;
              //       case "quantity":
              //         sumCell = sumCell = numFun.sumNumFun(
              //           data,
              //           column.property,
              //           2
              //         );
              //         break;
              //       default:
              //         sumCell = "-";
              //         break;
              //     }
              //     sums.push(sumCell);
              //   });
              //   // 返回一个二维数组的表尾合计
              //   return [sums];
              // }
            },
            fields: [
              {
                name: this.$t("gather") + this.$t("invoicePCS"),
                key: "total",
                width: 100,
              },
              {
                name: this.$t("out") + this.$t("invoicePCS"),
                key: "quantity",
                component: "Input",
                width: 100,
                placeholder() {
                  return (
                    this.$t("enter") + this.$t("out") + this.$t("invoicePCS")
                  );
                },
              },
              {
                name: this.$t("Remarks"),
                key: "remarks",
                component: "Input",
                placeholder() {
                  return this.$t("enter") + this.$t("Remarks");
                },
              },
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                // width({ field }) {
                //   return field.list.length * 40 + 40;
                // },
                list: [
                  {
                    name: () => this.$t("order_submit"),
                    type: "submit",
                    fnName: "submitFun",
                    bind: {
                      type: "warning",
                    },
                    show({ row }) {
                      return !row.id;
                    },
                    id: 850,
                  },
                  {
                    name: () => this.$t("update"),
                    type: "update",
                    fnName: "submitFun",
                    bind: {
                      type: "success",
                    },
                    show({ row }) {
                      return "id" in row;
                    },
                    id: 850,
                  },
                ],
                methods: {
                  submitFun({ row, rowIndex, field }) {
                    row["type"] = "out";
                    this.handleRequestMethods("outInSubmit", row, true).then(
                      (e) => {
                        this.handleRequestMethods("getOutInList", {
                          type: "out",
                          id: row.packing_id,
                        }).then((res) => {
                          this.getModal("out").list = res.payload.list;
                          if (res.payload.insert) {
                            this.getModal("out").list.unshift(
                              res.payload.insert
                            );
                          }
                        });
                        // close();
                      }
                    );
                  },
                },
              },
            ],
          },
        },
        setHkAgent: {
          methods: {
            ok({ row, close }) {
              row["type"] = 3;
              this.$page
                .handleRequestMethods("addZhongGang", row, true)
                .then((e) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            title: () => this.$t("setting") + this.$t("HKagency"),
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              hk_agent: [
                {
                  required: true,
                  message: "Please select the track",
                  trigger: "change",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ hk_agent: 24 }],
          fields: [
            {
              key: "hk_agent",
              name: () => this.$t("HKagency"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("HKagency");
              },
              options: this.hkAgentList,
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "timeType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            config: {
              label({ row, field }) {
                return this.$t(row.label);
              },
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["DBL_PACKING_SELECT_TIME"]))
                  .data.payload["DBL_PACKING_SELECT_TIME"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "warehouseId",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          {
            key: "operator",
            placeholder() {
              return this.$t("select") + this.$t("status_operator");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
            config: { label: "account", value: "id" },
            methods: {
              async list({ field, row }) {
                let res = (await getAllClient()).data.payload.rows;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keywords") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getKeysType("AIR_PACKING_KEYWORDS")).data
                  .payload;
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "exportFun",
              bind: {
                type: "success",
              },
              disabled() {
                return !this.selectAll.length;
              },
              // list: [
              //   {
              //     name: () => this.$t("LibraryDay"),
              //     type: "exportOutboundData",
              //     fnName: "exportFun"
              //   },
              //   {
              //     name: () => this.$t("Customsinfo"),
              //     type: "exportCustomsData",
              //     fnName: "exportFun"
              //   },
              //   {
              //     name: () => this.$t("packingData"),
              //     type: "exportPackingZip",
              //     fnName: "exportFun"
              //   },
              //   {
              //     name: () => this.$t("ListData"),
              //     type: "ListData",
              //     fnName: "ListData",
              //     disabled() {
              //       return !this.selectAll.length;
              //     }
              //   }
              // ]
            },
          ],
          methods: {
            exportFun({ field, searchForm }) {
              this.exportExc();
              // let data = {
              //   startTime: searchForm.startTime,
              //   endTime: searchForm.endTime,
              //   timeType: searchForm.timeType,
              //   warehouseId: searchForm.warehouseId,
              //   operator: searchForm.operator,
              //   keywords: searchForm.keywords
              // };
              // this.openLoading();
              // this.handleRequestMethods(field.type, data, false, true).then(
              //   res => {
              //     window.open(globalUrl + res.payload.url);
              //   }
              // );
            },
            // 导出列表数据
            ListData() {
              let fields = [
                {
                  name: this.$t("packing_number"),
                  key: "packing_number",
                },
                {
                  name: this.$t("ShippingDate"),
                  key: "outbound_time",
                },
                {
                  name: this.$t("createUser"),
                  key: "operator_name",
                },
                {
                  name: this.$t("bagsNum"),
                  key: "package_total",
                },
                {
                  name: this.$t("skuVolume"),
                  key: "volume_size",
                },
                {
                  name: this.$t("CustomsClearer"),
                  key: "clearance_agent_name",
                },
                {
                  name: this.$t("orderNums"),
                  key: "order_total",
                },
                {
                  name: this.$t("actual_weight"),
                  key: "order_weight",
                },
              ];
              this.openLoading();
              this.handleRequestMethods(
                "exportPacking",
                {
                  packing_id: this.selectAll.map((item) => item.id),
                },
                false,
                true
              ).then((res) => {
                this.exportExc({ data: res.payload, fields });
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
          show: false,
        },
        {
          name: () => this.$t("packing_number"),
          key: "packing_number",
          align: "center",
          minWidth: 150,
        },
				{
				  name: () => this.$t("clientName"),
				  key: "client_name",
				  align: "center",
				  minWidth: 100,
				},
        {
          name: () => this.$t("Weight"),
          key: "weight",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("skuVolume"),
          key: "volume",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("number_of_bags"),
          key: "quantity",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("liquidPCS"),
          key: "liquid_num",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("ElectricityPCS"),
          key: "charged_num",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("Billing") + this.$t("invoiceWeight"),
          key: "charging_weight",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehosueTitle",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("endGang"),
          key: "target_airport",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$t("agentName"),
          key: "agent_name",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("HKagency"),
          key: "hk_agent_txt",
          width: 130,
          // render: (h, params) => {
          //   return h(
          //     "div",
          //     {
          //       style: {
          //         overflow: "hidden",
          //         "text-overflow": "ellipsis",
          //         "white-space": "nowrap",
          //         width: params.row.hk_agent.length > 6 ? "101%" : "100%"
          //       }
          //     },
          //     [
          //       h(
          //         !params.row.hk_agent ? "Button" : "span",
          //         {
          //           props: {
          //             type: "warning",
          //             size: "small"
          //           },
          //           on: {
          //             click: () => {
          //               if (!params.row.hk_agent) {
          //                 this.$refs["table"]
          //                   .getModal("setHkAgent")
          //                   .open({ id: params.row.id });
          //               }
          //             }
          //           }
          //         },
          //         params.row.hk_agent
          //           ? params.row.hk_agent
          //           : this.$t("setting") + this.$t("HKagency")
          //       )
          //     ]
          //   );
          // }
        },
        {
          name: () => this.$t("delivery_method"),
          key: "lower_port",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("createUser"),
          key: "operator_name",
          align: "center",
          minWidth: 100,
        },

        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 180,
        },
        {
          name: () => this.$t("inboundTime"),
          key: "inbound_time",
          component: "Button",
          align: "center",
          minWidth: 150,
          bind: {
            type: "warning",
            size: "small",
          },
          methods: {
            render: ({ value }) => {
              return value ? value : this.$t("addTo") + this.$t("inboundTime");
            },
            click({ row }) {
              this.$page
                .getModal("settime")
                .open(
                  { id: row.id, type: "in", time: new Date() },
                  function () {
                    this.setTitle(this.$t("update") + this.$t("inboundTime"));
                    this.fields[0].name = this.$t("inboundTime");
                  }
                );
            },
          },
        },
        {
          name: () => this.$t("outboundTime"),
          key: "outbound_time",
          component: "Button",
          align: "center",
          minWidth: 150,
          bind: {
            type: "warning",
            size: "small",
          },
          disabled: ({ row }) => {
            return row.inbound_time === "";
          },
          methods: {
            render: ({ value }) => {
              return value ? value : this.$t("addTo") + this.$t("outboundTime");
            },
            click({ row }) {
              this.$page
                .getModal("settime")
                .open(
                  { id: row.id, type: "out", time: new Date() },
                  function () {
                    this.setTitle(this.$t("update") + this.$t("outboundTime"));
                    this.fields[0].name = this.$t("outboundTime");
                  }
                );
            },
          },
        },
        {
          name: () => this.$t("toHKtime"),
          key: "to_hk_time",
          component: "Button",
          align: "center",
          minWidth: 150,
          bind: {
            type: "warning",
            size: "small",
          },
          methods: {
            render: ({ value }) => {
              return value ? value : this.$t("addTo") + this.$t("toHKtime");
            },
            click({ row }) {
              this.$page
                .getModal("settime")
                .open(
                  { id: row.id, type: "hk", time: new Date() },
                  function () {
                    this.setTitle(this.$t("update") + this.$t("toHKtime"));
                    this.fields[0].name = this.$t("toHKtime");
                  }
                );
            },
          },
        },
        {
          type: "btns",
          width: 100,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
            },
            {
              name: () => this.$t("inbound"),
              type: "inbound",
              fnName: "inboundFun",
              bind: {
                type: "primary",
              },
              id: 804,
            },
            {
              name: () => this.$t("out"),
              type: "out",
              fnName: "outFun",
              bind: {
                type: "warning",
              },
              id: 804,
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
              show: ({ row }) => {
                return row.is_del == 1;
              },
              id: 803,
            },
          ],

          methods: {
            updateFun({ row }) {
              this.getModal("update").open(row, function () {
                this.setTitle(this.$t("update") + row.packing_number);
              });
            },
            async showFun({ row }) {
              let res = await this.handleRequestMethods("showDblpacking", {
                packing_number: [row.packing_number],
              });
              console.log(res, this.getModal("show"));
              this.getModal("show").open({ data: res.payload.rows }, () => {
                this.getModal("show").setTitle(
                  this.$t("show") + row.packing_number
                );
                // this.getModal("show").table.fields[0].name = () => {
                //   return this.$t("packingNum");
                // };
                this.getModal("show").list = res.payload.rows;
              });
            },
            trackFun({ row }) {
              this.getModal("track").open(
                { time: new Date(), status_code: "", id: row.id },
                function () {
                  this.setTitle(this.$t("trackRecord"));
                }
              );
            },
            // 出库
            outFun({ row }) {
              this.handleRequestMethods("getOutInList", {
                type: "out",
                id: row.id,
              }).then((res) => {
                this.getModal("out").open({}, function () {
                  this.list = res.payload.list;
                  if (res.payload.insert) {
                    this.list.unshift(res.payload.insert);
                  }
                  this.setTitle(this.$t("out"));
                });
              });
            },
            // 入库
            inboundFun({ row }) {
              console.log(this);
              this.handleRequestMethods("getOutInList", {
                type: "in",
                id: row.id,
              }).then((res) => {
                this.getModal("inbound").open({}, function () {
                  this.list = res.payload.list;
                  if (res.payload.insert) {
                    this.list.unshift(res.payload.insert);
                  }
                  this.setTitle(this.$t("inbound"));
                });
              });
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  '"' +
                  row.packing_number +
                  '"' +
                  this.$t("packing_number") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    {
                      id: row.id,
                    },
                    true
                  ).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
